import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/check.svg'
import _imports_1 from '../assets/detail.svg'


const _hoisted_1 = { class: "link-to-account" }
const _hoisted_2 = { class: "message" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "detail_icon",
  src: _imports_0,
  align: "right"
}
const _hoisted_5 = {
  key: 1,
  class: "check_icon",
  src: _imports_1,
  align: "right"
}
const _hoisted_6 = { class: "button-area" }

import { nextTick, onMounted, ref } from "vue";
import { MEDIA_NAME } from "../consts/common";
import SnsAccountDialog from "../components/SnsAccountDialog.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import router from "../router";
import CommonButton from "./CommonButton.vue";
import ComfirmDialog from "./ComfirmDialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SnsAccounts',
  setup(__props) {

const showDialog = ref(false);
const showComfirmDialog = ref(false);
const accountName = ref("");
const selectedMediaType = ref(-1);
const dialog = ref<InstanceType<typeof SnsAccountDialog>>();
const comfirmDialog = ref<InstanceType<typeof ComfirmDialog>>();
const userInfoStore = UserInfoStore();
const loading = ref(true);
const message = ref("");
const subMessage = ref("");

function linkToAccount(index: number) {
  selectedMediaType.value = index;
  const data = userInfoStore.userSnsInfo.find((v) => v.media_type == index);
  if (data) {
    accountName.value = data.account_name;
  } else {
    accountName.value = "";
  }
  showDialog.value = true;
  dialog.value?.openDialog();
}
onMounted(async () => {
  document.title = "SNSアカウント登録";
  subMessage.value = `案件${
    userInfoStore.isRegistFromProjectDetail.title
  }\nの応募に必要な${
    MEDIA_NAME[userInfoStore.isRegistFromProjectDetail.mediaType]
  }アカウントの登録が済んでいません。`;
  if (userInfoStore.addressInfo.id > 0) {
    message.value = `案件詳細に戻ってよろしいですか`;
  } else {
    message.value = `配送先住所登録に進みます、よろしいですか`;
  }
  // SNSユーザー情報取得
  await userInfoStore.getUserSnsAccount();
  await nextTick();
  loading.value = false;
});
function isRegistered(index: number) {
  if (!userInfoStore.userSnsInfo) return false;
  else {
    const data = userInfoStore.userSnsInfo.find(
      (v) =>
        v.media_type == index
    );
    if (data) return true;
    else return false;
  }
}
// 案件詳細に戻る もしくは 次へ（配送先住所登録）
function Comfirm() {
  // 遷移元の案件のsnsアカウント登録がされていない場合は確認ダイアログを出す
  if (
    !userInfoStore.userSnsInfo.find(
      (v) => v.media_type == userInfoStore.isRegistFromProjectDetail.mediaType
    )
  ) {
    showComfirmDialog.value = true;
    comfirmDialog.value?.openDialog();
    // 配送先住所登録がまだの場合は配送先住所登録画面に遷移する
  } else if (
    userInfoStore.isRegistFromProjectDetail.show &&
        userInfoStore.addressInfo.id < 0
  ) {
    pushAddress()
  } else {
    userInfoStore.setIsRegistFromProjectDetail({
      show: false,
      title: "",
      mediaType: -1,
    });
    router.replace("/project-detail");
  }
}

// 案件詳細に戻る
function backToProjectDetail() {
  showComfirmDialog.value = false;
  userInfoStore.setIsRegistFromProjectDetail({
    show: false,
    title: "",
    mediaType: -1,
  });
  router.replace("/project-detail");
}

// 配送先住所登録へ
function pushAddress() {
  router.replace("/address");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" アカウント登録 "),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, _cache[5] || (_cache[5] = [
        _createElementVNode("p", null, "案件に応募するためにはSNS登録が必要です", -1 /* HOISTED */)
      ]), 512 /* NEED_PATCH */), [
        [_vShow, !_unref(userInfoStore).userSnsInfo.length]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MEDIA_NAME), (sns, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (!loading.value ? linkToAccount(index) : ''),
          class: "list__item"
        }, [
          _createElementVNode("p", null, _toDisplayString(sns), 1 /* TEXT */),
          (isRegistered(index))
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ], 8 /* PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (
        _unref(userInfoStore).isRegistFromProjectDetail.show &&
        _unref(userInfoStore).addressInfo.id > 0
      )
        ? (_openBlock(), _createBlock(CommonButton, {
            key: 0,
            data: {
        status: !loading.value ? 0 : 2,
        button: `案件詳細に戻る`,
      },
            onClick: _cache[0] || (_cache[0] = ($event: any) => (Comfirm()))
          }, null, 8 /* PROPS */, ["data"]))
        : _createCommentVNode("v-if", true),
      (
        _unref(userInfoStore).isRegistFromProjectDetail.show &&
        _unref(userInfoStore).addressInfo.id < 0
      )
        ? (_openBlock(), _createBlock(CommonButton, {
            key: 1,
            data: {
        status: !loading.value ? 0 : 2,
        button: `次へ`,
      },
            onClick: _cache[1] || (_cache[1] = ($event: any) => (Comfirm()))
          }, null, 8 /* PROPS */, ["data"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(SnsAccountDialog, {
      ref_key: "dialog",
      ref: dialog,
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
      "media-type": selectedMediaType.value,
      "account-name": accountName.value
    }, null, 8 /* PROPS */, ["modelValue", "media-type", "account-name"]),
    _createVNode(ComfirmDialog, {
      ref_key: "comfirmDialog",
      ref: comfirmDialog,
      modelValue: showComfirmDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showComfirmDialog).value = $event)),
      "sub-message": subMessage.value,
      message: message.value,
      button: _unref(userInfoStore).addressInfo.id > 0 ? `案件詳細に戻る` : `次へ`,
      onApply: _cache[4] || (_cache[4] = ($event: any) => (
      _unref(userInfoStore).addressInfo.id > 0 ? backToProjectDetail() : pushAddress()
    ))
    }, null, 8 /* PROPS */, ["modelValue", "sub-message", "message", "button"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})